import { useEffect, useState } from "react";
import axios from "axios";
import { Camera, ExternalLink } from "lucide-react";
import { useI18n } from "../i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PhotoGallery({ gkey, query, name }) {
  const { tr } = useI18n();
  const [photos, setPhotos] = useState(null);

  useEffect(() => {
    setPhotos(null);
    axios.get(`${API}/gallery/${encodeURIComponent(gkey)}`, { params: { q: query } })
      .then((r) => setPhotos(r.data.photos))
      .catch(() => setPhotos([]));
  }, [gkey, query]);

  if (photos && photos.length === 0) return null;

  return (
    <section id="photos" className="scroll-mt-32 mb-12" data-testid="photo-gallery-section">
      <div className="flex items-center gap-3">
        <span className="w-9 h-9 rounded-xl bg-[#F0F9FF] flex items-center justify-center"><Camera size={17} className="text-[#0284C7]" /></span>
        <h2 className="text-xl font-extrabold text-[#0F2557] flex-1">{tr("Photos of")} {name}</h2>
        <a href="https://photopulse.pro" target="_blank" rel="noreferrer" data-testid="gallery-photopulse-link"
          className="text-xs font-extrabold text-[#0284C7] inline-flex items-center gap-1.5 hover:underline">
          PhotoPulse.pro <ExternalLink size={11} />
        </a>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mt-4">
        {photos === null && Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className="aspect-[4/3] rounded-2xl bg-[#EAF2FD] animate-pulse" />
        ))}
        {photos?.map((p, i) => (
          <figure key={i} data-testid="gallery-photo" className="group">
            <a href={p.source_url} target="_blank" rel="noreferrer" className="block aspect-[4/3] rounded-2xl overflow-hidden border border-[#E5EDF7]">
              <img src={p.thumb} alt={p.alt} loading="lazy"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </a>
            <figcaption className="text-[0.58rem] font-semibold text-[#94A3B8] mt-1.5 leading-snug truncate">
              {tr("Photo by")}{" "}
              <a href={p.photographer_url} target="_blank" rel="noreferrer" data-testid="gallery-photographer-link" className="text-[#0284C7] hover:underline">{p.photographer}</a>
              {" "}{tr("on")}{" "}
              <a href={p.source_url} target="_blank" rel="noreferrer" data-testid="gallery-source-link" className="text-[#0284C7] hover:underline">{p.source_name}</a>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
